/* eslint react/prop-types: 0 */
import React from 'react';
import classNames from 'classnames';
import { EMPTINESS_SIGN } from 'rp-react-table';
import get from 'lodash/get';
import { isRunner } from './helper';
import { JockeyLink } from '../../../shared/links/ProfileLink';
import { formatDate } from '../../../utils/date';
import WeightCell from './WeightCell';
import ResultLink from '../../../shared/links/ResultLink';
import ReplayLink from '../../../shared/links/ReplayLink';
import NonRunnerSwitcherTableCell from './NonRunnerSwitcherTableCell';

export const raceDatetimeCell = (props) => {
    const isVideoAvailable = !!get(props, 'videoDetail[0].finishRaceUid');
    return (
        <div className="hp-formTable__dateWrapper">
            {isVideoAvailable && <ReplayLink {...props} />}
            <ResultLink
                {...props}
                className={classNames(!isVideoAvailable && 'hp-formTable__withoutVideo')}
            >
                {formatDate(props.raceDatetime, 'DDMMMYY')}
            </ResultLink>
        </div>
    );
};

export const oddsValueCell = ({ raceOutcomeCode, oddsDesc }) =>
    (<NonRunnerSwitcherTableCell
        code={raceOutcomeCode}
        value={oddsDesc}
        zeroToDash
    />);

export const jockeyShortNameCell = rowData => (isRunner(rowData) ? (
    <span>
        <JockeyLink {...rowData} />
        {!!rowData.weightAllowanceLbs && (
            <sup className="hp-formTable__jockeyAllowance">
                {rowData.weightAllowanceLbs}
            </sup>
        )}
    </span>
) : EMPTINESS_SIGN);

export const officialRatingRanOffCell = ({ raceOutcomeCode, officialRatingRanOff }) => (
    <NonRunnerSwitcherTableCell
        code={raceOutcomeCode}
        value={officialRatingRanOff}
        zeroToDash
    />
);

export const rpTopspeedCell = ({ raceOutcomeCode, rpTopspeed }) => (
    <NonRunnerSwitcherTableCell
        code={raceOutcomeCode}
        value={rpTopspeed}
    />
);

export const rpPostmarkCell = ({ raceOutcomeCode, rpPostmark }) => (
    <NonRunnerSwitcherTableCell
        code={raceOutcomeCode}
        value={rpPostmark}
    />
);

export const weightCarriedLbsCell = rowData => (
    isRunner(rowData) ?
        <WeightCell {...rowData} /> :
        EMPTINESS_SIGN
);



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/columnsCells.jsx